import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
// import calenderIcon from "../../assets/img/calenderIcon.svg";
import { reportSelector } from "../Report/ReportSlice";
import CloseButton from "./CloseButton";
import LoaderComponent from "./LoaderComponent";
import Modal from "./Modal";
import { AppIcons } from "../../assets/icon/appIcons";

const SaveFilter = ({ handleCancelClick, handleSaveClick }) => {
  const { t } = useTranslation("common");
  const [saveText, setSaveText] = useState("");

  const { isFetchingSaveFilter } = useSelector(reportSelector);

  const handleResetClick = () => {
    setSaveText("");
  };

  return (
    <Modal show={true} close={handleCancelClick} justify="center">
      <div className="modal-header">
        <h6 className="modal-title d-flex align-items-center fs-22">
          {/* <img src={calenderIcon} loading="lazy" /> */}
          <img
            src={AppIcons.save}
            alt=""
            className="fs-25"
            style={{ width: 22, height: 22 }}
            loading="lazy"
          />
          {t("commonUi.saveFilter", { defaultValue: "Save Filter" })}
        </h6>
        <CloseButton theme={"dark"} onClick={handleCancelClick} />
      </div>
      <div className="modal-body py-3 px-3 bg-white">
        {isFetchingSaveFilter ? (
          <LoaderComponent />
        ) : (
          <>
            <h3 className="fs-20 fw-600 mb-0">
              {t("saveFilterModal.wantToSave", {
                defaultValue: "Do you want to save this filter?",
              })}
            </h3>
            <p className="small text-gray">
              {t("saveFilterModal.description", {
                defaultValue:
                  "Save filters for quick access and improved productivity.",
              })}
            </p>
            <div className="input my-2">
              <label className="form-label text-black fw-500">
                {t("saveFilterModal.enterName", { defaultValue: "Enter Name" })}
              </label>
              <input
                type="text"
                className="form-control w-full fs-14"
                placeholder={t("saveFilterModal.namePlaceholder", {
                  defaultValue: "Give your preferred and relevant name to this filter",
                })}
                value={saveText}
                onChange={(e) => setSaveText(e.target.value)}
              />
            </div>
          </>
        )}
      </div>
      <div className="modal-footer d-block bg-white">
        <div className="row g-3">
          <div className="col-6 mt-0">
            <button
              type="button"
              className="btn fs-16 fw-500 br-12 w-100 px-4 py-2 border_lightgray_1 me-2"
              onClick={handleResetClick}
            >
              {t("saveFilterModal.reset", { defaultValue: "Reset" })}
            </button>
          </div>
          <div className="col-6 mt-0">
            <button
              onClick={() => handleSaveClick(saveText)}
              className="cbtn text-white btn w-100 fs-16 fw-500 br-12 px-4 py-2 border_lightgray_1"
            >
              {t("save", { defaultValue: "Save" })}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SaveFilter;
